<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-certificates">
        <form class="mc-certificates__form mc-form" id="certificateForm" @submit.prevent="submitForm" method="post" autocomplete="off">
          <div class="mc-certificates__checkout">
            <picture class="mc-certificates__form-picture">
              <img class="mc-certificates__form-image" src="/assets/content/cards/img-big-1.png" width="330" height="207" alt="">
            </picture>
            <div class="mc-certificates__total">
                                <span class="mc-certificates__total-title">
                                    Итого
                                </span>
              <span class="mc-certificates__total-value">
                                    {{ denomination_value }} ₽
                                </span>
            </div>
            <div v-if="serverError" class="mc-form__message mc-form__message--alert" v-html="serverError">

            </div>
            <fieldset class="mc-form__fieldset">
              <div class="mc-form__field" :class="{ isError: errors.name }">
                <label class="mc-form__label" for="certificateFormName">
                  Имя и фамилия
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.name" class="mc-form__error-text">
                  {{ errors.name }}
                </span>
                <input class="mc-form__input" id="certificateFormName" type="text" v-model="formData.name" placeholder="Ольга Иванова" required>
              </div>
              <div class="mc-form__field" :class="{ isError: errors.phone }">
                <label class="mc-form__label" for="certificateFormPhone">
                  Телефон
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.phone" class="mc-form__error-text">
                  {{ errors.phone }}
                </span>
                <MaskInput class="mc-form__input" id="certificateFormPhone" v-model="formData.phone" mask="+7 (###) ###-##-##" placeholder="+7 (___) ___-__-__" required />
              </div>
              <div class="mc-form__field" :class="{ isError: errors.email }">
                <label class="mc-form__label" for="certificateFormEmail">
                  E-mail
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.email" class="mc-form__error-text">
                  {{ errors.email }}
                </span>
                <input class="mc-form__input" id="certificateFormEmail" type="email" v-model="formData.email" placeholder="example@mail.ru" required>
              </div>
            </fieldset>
            <p class="mc-form__notice mc-form__notice--centered">
              Нажимая на кнопку "Отправить", вы принимаете условия&nbsp;<router-link to="/info/oferta/">Публичной оферты</router-link>
            </p>
          </div>
          <button class="mc-form__button-submit mc-button mc-button--color js-button-submit" type="submit" :disabled="isSubmitting">
                            <span class="mc-button__text">

              {{ isSubmitting ? 'Сохранение...' : 'Оплатить заказ банковской картой' }}
                            </span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import axios from 'axios';
import { MaskInput } from 'vue-3-mask';

export default {
  data: () => ({
    formData: {
      denomination: false,
      name: '',
      phone: '',
      email: '',
    },
    errors: {},
    serverError: null,
    formSubmitted: false,
    isSubmitting: false
  }),
  mounted() {

  },
  async created() {
    this.formData.denomination = this.$route.query.id;
    await this.fetchCertificate();
  },
  computed: {
    ...mapGetters([
      'certificate',
      'certificateLoading',
      'certificateError',
      'certificateLoaded',
    ]),
    denomination_value() {
      if (this.certificate.length === 0 || this.certificate.length == undefined)
        return '';
      return this.certificate.find((element) => parseInt(element.id) === parseInt(this.formData.denomination)).price
    },
  },
  components: {MaskInput},
  methods: {
    ...mapActions([
      'fetchCertificate'
    ]),
    scrollToFirstError() {
      this.$nextTick(() => {
        // Find first error element or server error message
        const firstErrorElement = this.serverError
            ? document.querySelector('.mc-form__message--alert')
            : document.querySelector('.isError');

        if (firstErrorElement) {
          // Scroll to the element with smooth behavior
          firstErrorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    },

    validateForm() {
      this.errors = {};



      // Validate name
      if (!this.formData.name.trim()) {
        this.errors.name = 'Имя обязательно';
      } else if (this.formData.name.length < 2) {
        this.errors.name = 'Имя должно содержать минимум 2 символа';
      }

      // Validate email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.formData.email.trim()) {
        this.errors.email = 'Email обязателен';
      } else if (!emailRegex.test(this.formData.email)) {
        this.errors.email = 'Некорректный формат email';
      }

      // Validate phone - with mask we can simplify the validation
      if (!this.formData.phone) {
        this.errors.phone = 'Телефон обязателен';
      } else if (this.formData.phone.includes('_')) {
        this.errors.phone = 'Телефон заполнен не полностью';
      }



      // Validate password fields
      if (!this.formData.denomination) {
        this.$router.push('/certificates/')
      }

      const isValid = Object.keys(this.errors).length === 0;

      if (!isValid) {
        this.scrollToFirstError();
      }

      return isValid;
    },

    async submitForm() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      this.serverError = null;

      try {
        // Prepare data for submission
        const formDataToSubmit = {
          ...this.formData,
        };

        const response = await axios.post('/api/certificate/', formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code != 'number' && response.data.errors[i].code!= 'cert')
              this.errors[response.data.errors[i].code] = response.data.errors[i].message;
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(response.data.errors);
        }

        this.formSubmitted = true;
        // Scroll to the success message
        this.$router.push('/certificates/success/?id='+response.data.data.id)

      } catch (error) {
        /*let errorMessage = 'Произошла техническая ошибка. Попробуйте еще раз.';

        if (error.response && error.response.data) {
          // Handle axios error responses
          errorMessage = error.response.data.message || errorMessage;
        } else if (error.message) {
          // Use the thrown error message
          errorMessage = error.message;
        }

        this.serverError = errorMessage;*/
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    }
  },
}
</script>

